import api from './api';

const TOKEN_KEY = 'token';
const CLIENTE_ID_KEY = 'clienteId';
const CLIENTE_CODIGO_KEY = 'clienteCodigo';
export const ADMIN_CLIENT_CODE = '0000000';

/**
 * Realiza login do cliente no painel
 * @param {{ codigo: string, senha: string }} credentials
 */
export async function loginCliente(credentials) {
  const response = await api.post('/clientes/login', credentials);

  if (response?.token) {
    localStorage.setItem(TOKEN_KEY, response.token);
  }

  if (response?.data?.id) {
    localStorage.setItem(CLIENTE_ID_KEY, String(response.data.id));
  }

  if (response?.data?.codigo) {
    localStorage.setItem(CLIENTE_CODIGO_KEY, String(response.data.codigo));
  }

  return response;
}

export function getClienteId() {
  return localStorage.getItem(CLIENTE_ID_KEY);
}

export function getClienteCodigo() {
  return localStorage.getItem(CLIENTE_CODIGO_KEY);
}

export function isAdminCliente() {
  return getClienteCodigo() === ADMIN_CLIENT_CODE;
}

export function isAuthenticated() {
  return !!localStorage.getItem(TOKEN_KEY);
}

export function logout() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(CLIENTE_ID_KEY);
  localStorage.removeItem(CLIENTE_CODIGO_KEY);
}
